import { Model, Attr, BelongsTo, HasOne, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Lot from './Lot';
import User from './auth/User';

@Model()
export default class Bid extends ApplicationRecord {
  static jsonapiType = 'bids';

  static listHeaders() {
    return [
      {
        text: 'Bidder ID',
        value: 'bidderNumber',
        width: 110,
        sortable: false,
      },
      {
        text: 'Value',
        value: 'value',
      },
      {
        text: 'User',
        value: 'user.email',
      },
      {
        text: 'Won',
        value: 'won',
        width: 100,
        align: 'center',
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return Bid.includes(['user']);
  }

  static defaultOptions() {
    return {
      sortBy: ['value'],
      sortDesc: [true],
    };
  }

  @Attr() created: string;
  @Attr() bidderNumber: string;
  @Attr() value: number;
  @Attr() won: boolean;

  @HasOne() user: User;
  @HasOne() lot: Lot;

  get formattedValue() {
    const dollarVal = this.value / 100;
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(dollarVal);
  }
}
